<template>
  <div>
    <AtomLoadingSecondary v-if="showLoadingState"/>

    <div v-else v-show="configParams || Object.values(autorizador.parametros).length">
      <form
        autocomplete="off"
        class="m-form"
        @submit.prevent="createAutorizador"
      >
        <h3 class="m-form-title">
          {{ `${$t('mEditionBillingFiscalAuthorizerEditAuthorizer.title')}` }}
        </h3>

        <div class="m-container-primary">
          <div class="row" style="display: flex; flex-wrap: wrap;" v-if="configParams">

            <div
              v-for="(field, key) in configParams"
              :key="key"
              class="column column-8"
            >
              <p class="a-input-wrapper-column margin-top-medium">

                <template v-if="field.type === 'download_button'">
                  <label>{{ field.label }}</label>
                  <button
                    type="button"
                    class="a-button-billing-primary a-button-primary"
                    style="margin-top: 5px;"
                    @click="downloadBase64File(field.file_content, field.file_name)"
                  >
                    Descargar PDF
                  </button>
                </template>

                <template v-else-if="field.type === 'file'">
                  <label :for="key">{{ field.label }}</label>
                  <input
                    :id="key"
                    :name="key"
                    type="file"
                    class="a-input-primary"
                    :required="field.required && !formValues[key]"
                    @change="handleFileUpload($event, key)"
                  >
                </template>

                <template v-else-if="field.type === 'select'">
                  <label :for="key">{{ field.label }}</label>
                  <select
                    :id="key"
                    :name="key"
                    class="a-input-primary"
                    v-model="formValues[key]"
                    :class="{ 'a-input-danger': hasError(key) }"
                    :disabled="field.edit === false"
                    @blur="markTouched(key)"
                  >
                    <option value="">Seleccione una opción...</option>
                    <option v-for="opt in field.options" :key="opt" :value="opt">
                      {{ opt }}
                    </option>
                  </select>
                </template>

                <template v-else>
                  <label :for="key">{{ field.label }}</label>
                  <input
                    :id="key"
                    :name="key"
                    :type="field.type || 'text'"
                    class="a-input-primary"
                    v-model="formValues[key]"
                    :class="{ 'a-input-danger': hasError(key) }"
                    :placeholder="field.placeholder || ''"
                    :readonly="field.edit === false"
                    @blur="markTouched(key)"
                  >
                </template>

                <small v-show="hasError(key)" class="text-color-danger">
                  {{ $t('mEditionBillingFiscalAuthorizerEditAuthorizer.validation.required') }}
                </small>

                <br v-if="field.help">
                <small class="quote quote-billing-primary font-weight-regular font-size-small">
                  {{ field.help }}
                </small>

              </p>
            </div>

          </div>
        </div>

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.goBack"
          @goBackPage="goBackPage"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </form>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionBillingFiscalAuthorizerEditAuthorizer',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionBillingFiscalAuthorizerEditAuthorizer.buttonPrimary'),
        class: 'margin-right-medium margin-top-medium',
        sending: false,
        type: 'submit'
      },
      buttonSecondary: {
        goBack: {
          text: this.$t('mEditionBillingFiscalAuthorizerEditAuthorizer.buttonSecondary'),
          class: 'margin-top-medium margin-right-medium',
          type: 'button',
          component: '',
          icon: 'fas fa-arrow-left',
          method: 'goBackPage'
        }
      },
      autorizador: {
        academia_autorizador: '',
        descripcion: '',
        nombre: '',
        parametros: {},
        autorizador: ''
      },
      showLoadingState: true,

      configParams: null,
      formValues: {},
      touchedFields: {}
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    if (Object.values(this.$store.getters.getBillingFiscalAuthorizerEdit).length) {
      this.autorizador.nombre = this.$store.getters.getBillingFiscalAuthorizerEdit.nombre
      this.autorizador.autorizador = this.$store.getters.getBillingFiscalAuthorizerEdit.autorizador_fiscal
      this.autorizador.academia_autorizador = this.$store.getters.getBillingFiscalAuthorizerEdit.id_autorizador_fiscal
    } else {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`)
    }

    this.readAutorizadorConfiguracion()
  },

  methods: {

    goBackPage () {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`)
    },

    markTouched (key) {
      this.$set(this.touchedFields, key, true)
    },

    hasError (key) {
      const field = this.configParams[key]
      if (!field || !field.required) return false

      return this.touchedFields[key] && !this.formValues[key]
    },

    createAutorizador () {
      let hasErrors = false
      for (const key in this.configParams) {
        if (this.configParams[key].required && !this.formValues[key]) {
          this.$set(this.touchedFields, key, true)
          hasErrors = true
        }
      }

      if (hasErrors) return

      this.showLoadingState = true

      this.autorizador.parametros = { ...this.formValues }

      const payload = {
        ...this.autorizador.parametros,
        academia_autorizador: this.autorizador.academia_autorizador
      }

      this.$services.create('parametro', 'asociateAutorizadorFiscalAcademia', payload, [this.autorizador.autorizador, this.academiaId])
        .then(response => {
          this.showLoadingState = false
          window.open(response.data, '_blank')
          this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.fiscalAuthorizer.subject')}`)
        })
        .catch(error => {
          this.showLoadingState = false
          this.$alerts.pushAlert('mEditionBillingFiscalAuthorizerEditAuthorizer', 'createAutorizador', 'error', 'a-alert-danger')
          console.log(error)
        })
    },

    readAutorizadorConfiguracion () {
      this.$services.read('parametro', 'readAutorizadoresParametros', { params: { academia_autorizador: this.autorizador.academia_autorizador } }, [this.autorizador.autorizador, this.academiaId])
        .then(response => {
          if (response.data) {
            this.configParams = response.data

            const initialValues = {}
            for (const key in response.data) {
              initialValues[key] = response.data[key].value || ''
            }
            this.formValues = initialValues
            this.autorizador.parametros = this.formValues
          }
          this.showLoadingState = false
        })
        .catch(error => {
          console.error(error)
          this.showLoadingState = false
        })
    },

    downloadBase64File (base64Content, fileName) {
      if (!base64Content) return

      const linkSource = `data:application/pdf;base64,${base64Content}`
      const downloadLink = document.createElement('a')

      downloadLink.href = linkSource
      downloadLink.download = fileName || 'documento.pdf'
      document.body.appendChild(downloadLink)

      downloadLink.click()
      document.body.removeChild(downloadLink)
    },

    handleFileUpload (event, key) {
      const file = event.target.files[0]

      if (file) {
        const reader = new FileReader()

        reader.onload = (e) => {
          this.$set(this.formValues, key, e.target.result)
          this.$set(this.touchedFields, key, true)
        }

        reader.readAsDataURL(file)
      }
    }
  }
}
</script>
